import { InsertInvitation } from "@mui/icons-material";
import { TextField } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/es";

const DatePicker = ({ text, date, onChange, color }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
      <DesktopDatePicker
        renderInput={(props) => <TextField {...props} fullWidth size="small"/>}
        size="small"
        label={text ? text : "Fecha"}
        value={dayjs(date)}
        onChange={onChange}
        sx={{ width: "100%" }}
        slots={{
          openPickerIcon: (props) => (
            <InsertInvitation
              fontSize="small"
              color={color ? color : "primary.main"}
              {...props}
            />
          ),
        }}
      />
    </LocalizationProvider>
  );
};

export default DatePicker;
